import React, { Component } from 'react';
import { http, baseURL } from "../misc/http";
import Layout from "../layout/Main";

export default class ConfirmEvent extends Component {
  render() {
    return (
      <Layout>
        
      </Layout>
    )
  }
}
